export const habaContactForm = {
  habaContactForm: {
    success: {
      title: 'Merci pour votre message',
      txt: "Vous recevrez la réponse à votre demande par e-mail à l'adresse suivante",
    },
    messages: {
      notValidError: 'Entrées non valides',
      serverError: 'Une erreur inconnue est survenue',
    },
    form: {
      legend: 'Formulaire de contact',
      reason: {
        label: 'Motif de votre demande',
        error: 'Veuillez sélectionner le motif de votre demande',
      },
      reference: {
        label: 'Sujet',
        error: "Veuillez saisir l'objet",
      },
      file: {
        label: 'Télécharger le fichier...',
        error: 'Veuillez sélectionner un fichier',
      },
      message: {
        label: 'Votre message',
        error: 'Veuillez saisir votre message',
      },
      isInstitution: {
        true: {
          label: 'Institution',
        },
        false: {
          label: 'Entreprise',
        },
      },
      name: {
        label: 'Nom',
        error: 'Veuillez saisir votre nom',
      },
      customerNumber: {
        label: 'Numéro de client (facultatif)',
        error: 'Veuillez saisir votre numéro de client',
      },
      orderNumber: {
        label: 'Numéro de commande (facultatif)',
        error: 'Veuillez saisir le numéro de commande',
      },
      street: {
        label: 'Rue*',
        error: 'Veuillez saisir la rue',
      },
      houseNumber: {
        label: 'Numéro de rue*',
        error: 'Veuillez saisir le numéro',
      },
      postcode: {
        label: 'Code postal*',
        error: 'Veuillez saisir la code postal',
      },
      location: {
        label: 'Ville*',
        error: 'Veuillez saisir la ville',
      },
      country: {
        label: 'Pays',
        error: 'Veuillez sélectionner un pays',
      },
      email: {
        label: 'Adresse e-mail',
        error: 'Veuillez sélectionner une adresse e-mail',
      },
      isAgreed: {
        label:
          "J'ai lu les conditions générales de vente et la politique de confidentialité de Haba Familygroup.",
        error: '',
      },
      submit: 'Envoyer',
    },
  },
};
